import React from 'react';
export var RuPayCardArt = _ref => {
  var {
    title
  } = _ref;
  return React.createElement("svg", {
    "aria-labelledby": "rupay-card-art-title",
    "data-testid": "rupay-card-art",
    height: "24",
    role: "img",
    version: "1.1",
    viewBox: "0 0 38 24",
    width: "38",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", {
    id: "rupay-card-art-title"
  }, title), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, React.createElement("path", {
    d: "M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z",
    fill: "#000",
    fillRule: "nonzero",
    opacity: ".07"
  }), React.createElement("path", {
    d: "M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32",
    fill: "#FFF",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M32.106 9.045l1.667 3.044-3.505 3.046 1.838-6.09",
    fill: "#128242"
  }), React.createElement("path", {
    d: "M30.952 9.045l1.664 3.044-3.502 3.046 1.838-6.09",
    fill: "#E4712B"
  }), React.createElement("path", {
    d: "M4.227 14.027L5.89 8.521h2.657c.83 0 1.385.12 1.667.37.28.247.335.65.166 1.217a2.046 2.046 0 0 1-.47.836c-.213.222-.491.398-.835.527.291.064.477.192.56.384.083.192.073.472-.027.839l-.202.769v.02c-.06.216-.042.331.053.34l-.061.204H7.599c.006-.129.018-.245.03-.342.013-.1.029-.177.045-.23l.167-.55c.085-.286.09-.485.011-.6-.079-.118-.256-.176-.535-.176H6.56l-.576 1.899H4.227zm2.708-3.14h.81c.283 0 .492-.036.62-.113.13-.078.227-.21.283-.399.059-.193.044-.327-.04-.404-.083-.078-.283-.115-.599-.115h-.762l-.312 1.032zM15.312 9.964l-1.225 4.063h-1.49l.184-.595c-.262.237-.53.417-.8.532a2.098 2.098 0 0 1-.85.174c-.246 0-.457-.041-.628-.122a.823.823 0 0 1-.386-.368.974.974 0 0 1-.097-.53c.013-.207.093-.556.24-1.045l.635-2.11h1.629l-.634 2.1c-.092.307-.115.523-.07.64.048.119.173.18.377.18a.715.715 0 0 0 .52-.207c.145-.139.256-.345.34-.62l.628-2.092h1.627M14.721 14.027l1.66-5.506h2.284c.504 0 .894.027 1.172.087.278.058.495.151.657.283.203.172.327.385.378.641.048.256.02.554-.085.904-.187.615-.512 1.087-.977 1.417-.467.325-1.043.489-1.731.489H17.01l-.507 1.685H14.72zm2.694-3.03h.574c.372 0 .633-.042.785-.124.148-.082.253-.229.318-.437.064-.211.047-.359-.05-.441-.093-.082-.331-.124-.713-.124h-.573l-.34 1.126zM22.702 14.027l.017-.385c-.263.18-.529.317-.796.403a2.73 2.73 0 0 1-.853.13c-.462 0-.783-.115-.97-.338-.183-.223-.213-.544-.088-.954.12-.404.333-.701.641-.891.307-.193.818-.33 1.535-.419.091-.013.213-.024.366-.041.53-.056.828-.187.892-.399.033-.115.013-.201-.065-.254-.076-.054-.218-.081-.422-.081a.79.79 0 0 0-.417.1.61.61 0 0 0-.251.305h-1.588c.144-.457.436-.803.876-1.034.438-.235 1.016-.348 1.732-.348.336 0 .638.029.904.092.267.06.462.146.588.25.156.129.249.277.275.44.03.163-.003.396-.096.702l-.683 2.265a.416.416 0 0 0-.015.201.24.24 0 0 0 .09.142l-.036.114h-1.636zm.396-1.814a6.235 6.235 0 0 1-.677.192c-.438.109-.685.253-.739.432-.037.115-.022.203.04.27.06.064.164.097.311.097.27 0 .488-.063.65-.187.162-.126.283-.323.368-.596.015-.058.028-.099.036-.13l.011-.078zM24.35 15.629l.361-1.203h.466a.719.719 0 0 0 .365-.08.432.432 0 0 0 .183-.265.876.876 0 0 0 .035-.174c.004-.068.004-.139 0-.222l-.248-3.721h1.648l-.026 2.466 1.44-2.466h1.532l-2.544 4.044c-.289.452-.499.762-.632.932a2.002 2.002 0 0 1-.377.385 1.453 1.453 0 0 1-.521.259c-.19.051-.479.077-.867.077a11.924 11.924 0 0 1-.815-.032",
    fill: "#293267"
  })));
};
RuPayCardArt.defaultProps = {
  title: 'RuPay'
};